import initAppQueryParametersAppAction from 'modules/app/actions/init-app-query-parameters/index.js'

/**
 * @param props
 * @param props.location
 */
const initQueryParametersAppAction = (props) => {
  return (dispatch) => {
    dispatch(initAppQueryParametersAppAction(props))
  }
}

export default initQueryParametersAppAction
